// checks if an obj has at least one undefined or null value
// works with objects that contains arrays

export default function checkIfObjIsFull(obj: Record<any, any>) {
  let isObjFull = true

  for (const key in obj) {
    if (obj[key] === undefined || obj[key] === null) isObjFull = false

    if (typeof obj[key] === 'object') {
      const recursedCheck = checkIfObjIsFull(obj[key])
      if (!recursedCheck) isObjFull = false
    }
  }

  return isObjFull
}
